"use client";

import { toast } from "@/components/ui/toast";

/** In die Zwischenablage — mit Meldung, auch wenn der Browser es verweigert. */
export async function kopieren(text: string, was: string) {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(`${was} kopiert`);
  } catch {
    toast.error("Kopieren ging nicht", { description: "Bitte den Text markieren und von Hand kopieren." });
  }
}
